import { STAFF_STATUS } from '@/models/channels'

import { getDefaultState } from './state'

const clearState = state => {
  Object.assign(state, getDefaultState())
}

const clearStaffChannels = state => {
  state.staffChannels = null
}

const initPaginationState = state => {
  Object.assign(state, {
    currentPage: 1,
    staffFilter: {
      //Same fields from firestore
      status: STAFF_STATUS.AVAILABLE,
      id: null,
      role: null
    },
    sort: {
      //Same fields from firestore
      status: 'asc'
    }
  })
}

const setChannels = (state, channels) => {
  Object.assign(state, { channels })
}

const setStaffs = (state, staffs) => {
  Object.assign(state, { staffs })
}

const setStaffChannels = (state, staffChannels) => {
  Object.assign(state, { staffChannels })
}

const setDashboardDigest = (state, data) => {
  Object.assign(state, { dashboardDigest: data })
}

const incrementCurrentPage = state => ++state.currentPage

const resetCurrentPage = state => {
  state.currentPage = 1
}

const addFilter = (state, staffFilter) => {
  Object.assign(state, {
    staffFilter: {
      ...state.staffFilter,
      ...staffFilter
    }
  })
}

const addSort = (state, sort) => {
  Object.assign(state, {
    sort: {
      ...state.sort,
      ...sort
    }
  })
}

const setStaffRoles = (state, roles) => {
  Object.assign(state, { staffRoles: roles })
}

const setEndStaffResults = (state, isFinal) => {
  Object.assign(state, { endStaffResults: isFinal })
}

export default {
  clearState,
  initPaginationState,
  setChannels,
  setStaffs,
  incrementCurrentPage,
  setDashboardDigest,
  setStaffChannels,
  addFilter,
  setStaffRoles,
  addSort,
  clearStaffChannels,
  setEndStaffResults,
  resetCurrentPage
}
